import { defineApi } from 'services/api/defineApi';
import { attachRequestIdInterceptor } from 'services/api/interceptors';

// The AP (Accounts Payable) API — the default client. Replaces the former
// singleton apiClient + getConfig.
export const apApi = defineApi('ap');

// The payment API — different baseURL + headers, configured at boot by
// paymentApiClientInitializer.
export const payApi = defineApi('pay');

// dokka-pay requires an `X-Request-Id` on every request for log correlation.
// Attached to the pay client only — the AP API does not send it.
attachRequestIdInterceptor(payApi.client);
